<template>
    <v-card width="350px">
      <v-container>
        <!-- Brush Size Slider -->
        <v-row no-gutters align="center">
          <v-col>
            <v-slider
              :model-value="brushSize"
              @update:model-value="setBrushSize"
              density="compact"
              hide-details
              label="Brush Size"
              min="0"
              max="10"
              step="1"
            >
              <template v-slot:append>
                <v-text-field
                  :model-value="brushSize"
                  @input="setBrushSize"
                  variant="underlined"
                  class="mt-n1 pt-0"
                  style="width: 40px"
                  hide-details
                  type="number"
                  min="0"
                  max="10"
                />
              </template>
            </v-slider>
          </v-col>
        </v-row>
  
        <!-- Label Value Controls -->
        <v-row no-gutters align="center" class="mt-4">
          <v-col>
            <v-slider
              :model-value="labelValue"
              @update:model-value="setLabelValue"
              density="compact"
              hide-details
              label="Labels"
              min="0"
              max="40"
              step="1"
            >
              <template v-slot:prepend>
                <v-btn
                  color="error"
                  size="small"
                  class="mr-1"
                  @click="setLabelValue(1)"
                >
                  1
                </v-btn>
                <v-btn
                  color="white"
                  size="small"
                  class="mr-2"
                  @click="setLabelValue(0)"
                >
                  0
                </v-btn>
              </template>
              <template v-slot:append>
                <v-text-field
                  :model-value="labelValue"
                  @input="setLabelValue"
                  variant="underlined"
                  class="mt-n1 pt-0"
                  style="width: 40px"
                  hide-details
                  type="number"
                  min="0"
                  max="40"
                />
              </template>
            </v-slider>
          </v-col>
        </v-row>
  
        <!-- Paint Hint -->
        <v-row no-gutters align="center" class="mt-6">
          <v-col>
            <div class="text-caption text-grey">
              Press Q to paint
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </template>
  
  <script lang="ts">
  import { computed, defineComponent } from 'vue';
  import { useSurface3DAnnotationStore } from '@/src/store/tools/surfaceDrawings';
  
  export default defineComponent({
    name: 'SurfaceAnnotationControls',
  
    setup() {
      const drawingTools = useSurface3DAnnotationStore();
  
      // Brush Size
      const brushSize = computed(() => drawingTools.brushSize);
      const setBrushSize = (size: number) => {
        drawingTools.setBrushSize(Number(size));
      };
  
      // Label Value (Color)
      const labelValue = computed(() => drawingTools.labelValue);
      const setLabelValue = (value: number) => {
        drawingTools.setLabelValue(Number(value));
      };
  
      return {
        brushSize,
        setBrushSize,
        labelValue,
        setLabelValue,
      };
    },
  });
  </script>
  
  <style scoped>
  .mt-n1 {
    margin-top: -0.25rem;
  }
  
  .pt-0 {
    padding-top: 0;
  }
  </style>